import { GetServerSideProps } from 'next';

import Footer from '@/components/footer/FooterWrapper';
import Header from '@/components/header/Header';
import OnboardingHomepage from '@/components/homepage/OnboardingHomepage';
import Layout from '@/components/layout/LayoutWrapper';
import { InitRequest } from '@/hooks/store';
import { useRouterPush } from '@/hooks/utils/useRouterPush';
import { getInitialServerState } from '@/utils/pageGeneration/getServerSideProps';

const Home = () => {
	const routerPush = useRouterPush();
	return (
		<Layout pageName="ua-homepage">
			<Header onFreeCtaClick={async () => await routerPush('/signup-flow')} />
			<OnboardingHomepage />
			<Footer />
		</Layout>
	);
};

export const getServerSideProps: GetServerSideProps = async context => {
	const initialState = await getInitialServerState(context, [
		InitRequest.DEVICE,
		InitRequest.USER,
		InitRequest.PRICES,
	]);

	return {
		props: {
			initialState,
		},
	};
};

export default Home;
